import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import { Tooltip } from "@mui/material";

export const setDataWithKeyboardValueCheck = ({
  value,
  keyboardInputValue,
  keyName,
  onChangeFilter,
  format = "MM/DD/YYYY",
}: {
  value: any;
  keyboardInputValue?: string;
  keyName: string;
  onChangeFilter: (key: string, date: string) => void;
  format?: string;
}) => {
  if (keyboardInputValue) {
    if (!dayjs(value).isValid()) {
      return;
    }
    onChangeFilter(keyName, dayjs(value).format(format));
  } else {
    onChangeFilter(keyName, dayjs(value).format(format));
  }
};

function findDiffInArr(arr1: Array<any>, arr2: Array<any>) {
  if (arr1.length !== arr2.length) {
    return true;
  }
  let length = arr1.length;
  for (let idx = 0; idx < length; idx++) {
    if (arr1[idx] !== null && typeof arr1[idx] === "object") {
      const obj1 = arr1[idx];
      const obj2 = arr2[idx];
      const keys = new Set([...Object.keys(obj1), ...Object.keys(obj2)]);
      let objKeys = Array.from(keys);
      for (const key of objKeys) {
        if (obj1[key] !== obj2[key]) {
          return true;
        }
      }
    } else if (arr1[idx] !== arr2[idx]) {
      return true;
    }
  }
  return false;
}

export function compareObjectValues(obj1: Record<string, any>, obj2: Record<string, any>) {
  // Collect all keys from both objects
  const keys = new Set([...Object.keys(obj1), ...Object.keys(obj2)]);
  let objKeys = Array.from(keys);

  // Iterate over all keys
  for (const key of objKeys) {
    if (Array.isArray(obj1[key]) && Array.isArray(obj2[key])) {
      if (findDiffInArr(obj1[key], obj2[key])) {
        obj1.difference = [...(obj1?.difference || []), key];
      }
      continue;
    } else if (obj1[key] !== obj2[key]) {
      obj1.difference = [...(obj1?.difference || []), key];
    }
  }
  return obj1;
}

export function findDifferenceInArray(arr: any[]) {
  return arr.map((localobject, index) => {
    if (index === arr.length - 1) {
      return localobject;
    }
    return compareObjectValues(localobject, arr[index + 1]);
  });
}

export function getMonths() {
  return ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
}

export const extractFilters = (filter: any) => {
  return Object.keys(filter)
    .map((filterKey) => {
      if (filter[filterKey] === "") {
        return "";
      } else if (typeof filter[filterKey] === "number") {
        return `${filterKey}=${filter[filterKey]}`;
      } else if (filter[filterKey] === true || filter[filterKey] === false) {
        return `${filterKey}=${filter[filterKey]}`;
      } else if (Array.isArray(filter[filterKey])) {
        if (filter[filterKey].length > 0) {
          return `${filterKey}=${encodeURIComponent(filter[filterKey].join(","))}`;
        } else {
          return "";
        }
      } else {
        return filter[filterKey] ? `${filterKey}=${encodeURIComponent(filter[filterKey])}` : "";
      }
    })
    .filter((f) => !!f)
    .join("&");
};

export const getTotalProgressPrime = (values: any) => {
  let {
    progress_jan = "0",
    progress_feb = "0",
    progress_mar = "0",
    progress_apr = "0",
    progress_may = "0",
    progress_jun = "0",
    progress_jul = "0",
    progress_aug = "0",
    progress_sep = "0",
    progress_oct = "0",
    progress_nov = "0",
    progress_dec = "0",
  } = values;
  progress_jan = Number(progress_jan);
  progress_feb = Number(progress_feb);
  progress_mar = Number(progress_mar);
  progress_apr = Number(progress_apr);
  progress_may = Number(progress_may);
  progress_jun = Number(progress_jun);
  progress_jul = Number(progress_jul);
  progress_aug = Number(progress_aug);
  progress_sep = Number(progress_sep);
  progress_oct = Number(progress_oct);
  progress_nov = Number(progress_nov);
  progress_dec = Number(progress_dec);
  let totalProgress =
    progress_jan +
    progress_feb +
    progress_mar +
    progress_apr +
    progress_may +
    progress_jun +
    progress_jul +
    progress_aug +
    progress_sep +
    progress_oct +
    progress_nov +
    progress_dec;
  return totalProgress;
};


export const OverflowTip = ({ children }: any) => {
  const [isOverflowed, setIsOverflow] = useState(false);
  const textElementRef = useRef<any>();
  useEffect(() => {
    setIsOverflow(textElementRef.current.scrollWidth > textElementRef.current.clientWidth);
  }, []);
  return (
    <Tooltip
      componentsProps={{}}
      title={<div className="overflow-tooltip-hover">{children}</div>}
      disableHoverListener={!isOverflowed}
      disableInteractive
    >
      <div ref={textElementRef} className="overflow-tooltip">
        {children}
      </div>
    </Tooltip>
  );
};